import ConfirmButton from "components/Templates/ConfirmButton"
import {
  useEndUserCountLazyQuery,
  useMakeNotificationMutation,
} from "generated/graphql"
import { NOTIFICATION_TRIGGERS } from "graphql/notification/notification.queries.gql"
import React from "react"
import { useNavigate } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import replaceTemplateVariables from "utils/replace-template-variables"
import useNotificationTriggerStore from "./notification-trigger.store"

const TriggerWarning = ({ disabled }) => {
  const navigate = useNavigate()
  const { data, filters } = useNotificationTriggerStore(store => ({
    filters: store.getFilters(),
    data: store.data,
  }))

  const userQueryUid = data.userQuery?.codename
  const [fetch, { loading, data: tData }] = useEndUserCountLazyQuery()

  const [triggerNotification, { loading: mLoading }] =
    useMakeNotificationMutation({
      onCompleted({ triggerNotification: { success } }) {
        navigate("/d/registration/notifications", { replace: true })

        AppToaster.show({
          message: success
            ? `Notification sent successfully!`
            : "Unable to send the notification",
          intent: success ? "success" : "danger",
        })
      },
      onError() {
        AppToaster.show({
          message: "Unable to send the notification",
          intent: "danger",
        })
      },
      refetchQueries: [
        {
          query: NOTIFICATION_TRIGGERS,
          variables: {
            first: 15,
            skip: 0,
          },
        },
      ],
    })

  return (
    <ConfirmButton
      disabled={disabled}
      onOpened={() => {
        if (filters?.length) {
          fetch({
            variables: {
              filter: {
                userQueryUid,
                userFilters: filters,
              },
            },
          })
        }
      }}
      title={
        loading ? (
          `Fetching target user count...`
        ) : tData ? (
          <span>
            This trigger will send notifications to{" "}
            <b>{tData?.targetUserCount?.userCount}</b> users. Are you sure you
            want to continue?
          </span>
        ) : (
          `Please select a valid filter`
        )
      }
      confirmButtonProps={{
        loading: loading || mLoading,
        disabled: !tData || disabled,

        onClick() {
          const outputs = data.template?.dataSource?.outputs
          triggerNotification({
            variables: {
              broadcastTime: data.broadcastTime.toISOString(),
              content: {
                ...data.content,
                extraFields: {
                  ...data.content.extraFields,
                  data: JSON.stringify(data.content.extraFields.data),
                },
                title: replaceTemplateVariables(data.content.title, outputs),
                body: replaceTemplateVariables(data.content.body, outputs),
              } as any,
              providerUid: data.provider?.codename,
              userQueryUid: data?.userQuery?.codename,
              templateUid: data?.template?.codename,
              dataVariables: data?.dataVariables,
              providerVariables: data.providerVariables?.reduce?.(
                (prev, variable) => {
                  return {
                    ...prev,
                    ...(variable.key && { [variable.key]: variable.value }),
                  }
                },
                {}
              ),
              filters,
            },
          })
        },
      }}
    />
  )
}

export default TriggerWarning
